// Renders CMS-editable text with **highlight** markers as white spans.
// Non-string values (legacy JSX defaults) pass through untouched.
export function renderRich(value) {
  if (typeof value !== "string") return value;
  const parts = value.split(/(\*\*[^*]+\*\*)/g);
  if (parts.length === 1) return value;
  return parts.map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? (
      <span key={i} className="text-white">
        {part.slice(2, -2)}
      </span>
    ) : (
      part
    )
  );
}
